/* eslint-disable react-hooks/exhaustive-deps */
import {
	AppBar,
	Badge,
	Box,
	Button,
	CssBaseline,
	Grid,
	IconButton,
	Toolbar,
	Typography,
} from "@material-ui/core/";
import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core/styles";
import { Notifications } from "@material-ui/icons";
import { Alert, AlertTitle } from "@material-ui/lab";
import clsx from "clsx";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { NavLink, useHistory, useRouteMatch } from "react-router-dom";
import { config as url } from "../../common/config";
import AuthContext from "../../context/Auth/authContext";
import FetchDataContext from "../../context/fetchData/fetchDataContext";
import useSocket from "../../hooks/useSocket";
import { toast } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";
import colorChange from "../../utils/colorChanges";
import SpeedDial from "../molecules/Speedial";
import NavbarItem from "./NavbarItem";

import "./index.css";

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.default,
		width: "100%",
	},
	appBar: {
		background: `linear-gradient(left,#316B83,#6D8299)`,
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	toolbar: {
		alignItems: "center",
		justifyContent: "space-between",
		padding: theme.spacing(0, 1),
		...theme.mixins.toolbar,
	},
	content: {
		flexGrow: 1,
		backgroundColor: "whitesmoke",
		height: "100vh",
		// overflowY: "scroll",
		// marginTop: 20,
	},
	iconButton: {
		position: "relative",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "50px",
		height: "70px",
		border: "none",
		outline: "none",
		borderRadius: "50%",
		padding: "27px",
	},
	Box: {
		overflowY: "visible",
	},
	ButtonAlerts: {
		display: "block",
	},
	button: {
		justifyContent: "space-beetween",
	},
	footer: {
		marginTop: "1rem",
		// padding: "1rem",
		backgroundColor: theme.palette.background.default,
		position: "fixed",
		bottom: 0,
		right: 0,
	},
}));

const Home = (props) => {
	const { messages } = useSocket("/notif", "trigger_notif");
	const { path } = useRouteMatch();
	// const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();
	const BaseUrl = `${url.notification}`;
	const authContext = useContext(AuthContext);
	const { loadLogoImages, stateLogoImages } = authContext;

	const fetchData = useContext(FetchDataContext);
	const { getFetchData } = fetchData;
	const classes = useStyles();
	const [count, setCount] = useState(0);
	const [notif, setNotif] = useState([]);

	const Msgaa = ({ data }) => {
		return (
			<div
				style={{
					// paddingTop: 10,
					// paddingBottom: 10,
					backgroundColor: colorChange(data.status),
				}}
			>
				Ticket : {data.idticket}
				<br />
				<br />
				Title : {data.title_issue}
				<br />
				<br />
				Status : {data.status}
			</div>
		);
	};

	const handleToastData = (data) => {
		switch (data) {
			case "Open": {
				return toast;
			}
			case "On Progress": {
				return toast.info;
			}
			case "Finish": {
				return toast.success;
			}
			case "Reject": {
				return toast.error;
			}
			case "Close": {
				return toast.dark;
			}

			default:
				break;
		}
	};

	const handleToast = ({ data, message }) => {
		const customeToast = handleToastData(data.status);
		customeToast(<Msgaa data={data} />, {
			position: "top-right",
			autoClose: 15000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "dark",
		});
	};

	const Notification = async () => {
		try {
			let result = await getFetchData({ url: BaseUrl });

			if (result) {
				if (messages && messages.popup) {
					handleToast(messages);
				}
				setNotif(result.data);
				setCount(result.jumlah);
			}
			return result;
		} catch (error) {
			throw error;
		}
	};

	useEffect(() => {
		let cleanup = Notification();
		return () => cleanup;
	}, [messages]);

	useEffect(() => {
		let cleanup = loadLogoImages();
		return () => cleanup;
	}, []);

	return (
		<>
			<Grid className={classes.root}>
				<CssBaseline />
				<AppBar position="sticky" className={clsx(classes.appBar)}>
					{/* <ToastContainer
						style={{ width: "370px", gap: "16px" }}
						bodyClassName="toastBody"
					/> */}

					<Toolbar>
						<Button
							exact
							to="/"
							component={NavLink}
							activeClassName={classes.active}
							className={classes.button}
						>
							<img
								alt="logo-ticketing"
								src={
									stateLogoImages?.path_logo ?? "/assets/images/helpdesk1.png"
								}
								height="45"
								width="auto"
								style={{ justifyContent: "flex-start" }}
							/>
						</Button>

						<Grid
							container
							justifyContent="flex-end"
							alignItems="flex-end"
							alignContent="flex-start"
							direction="row"
						>
							<div>
								<Grid container alignContent="flex-end" direction="row">
									<PopupState variant="popover" popupId="demo-popup-popover">
										{(popupState) => (
											<>
												<IconButton
													variant="contained"
													color="inherit"
													className={classes.iconButton}
													{...bindTrigger(popupState)}
												>
													<Badge badgeContent={count} color="secondary">
														<Notifications
															fontSize="medium"
															onClick={() => setCount(0)}
														/>
													</Badge>
												</IconButton>
												<Popover
													{...bindPopover(popupState)}
													anchorOrigin={{
														vertical: "bottom",
														horizontal: "right",
													}}
													transformOrigin={{
														vertical: "top",
														horizontal: "right",
													}}
												>
													<Box className={classes.Box}>
														{notif?.length !== 0 &&
															notif?.map((row) => {
																return (
																	<Button
																		key={row.idticket}
																		className={classes.ButtonAlerts}
																		onClick={() =>
																			history.push(
																				`${path}/task/${row.idticket}`
																			)
																		}
																	>
																		<Alert severity="info">
																			<AlertTitle>{row.idticket}</AlertTitle>

																			<div style={{ display: "flex" }}>
																				<Typography
																					variant="BUTTON"
																					style={{
																						backgroundColor: colorChange(
																							row.status
																						).backgroundColor,
																						color: colorChange(row.status)
																							.color,
																						borderRadius: "25px",
																						width: "40%",
																					}}
																				>
																					{row.status}
																				</Typography>
																				&nbsp; &#10148; &nbsp;
																				<Typography
																					variant="BUTTON"
																					style={{
																						backgroundColor: colorChange(
																							row.priority
																						).backgroundColor,
																						color: colorChange(row.priority)
																							.color,
																						width: "40%",
																						borderRadius: "25px",
																					}}
																				>
																					{row.priority}
																				</Typography>
																			</div>

																			{moment(row.create_time).fromNow()}
																		</Alert>
																	</Button>
																);
															})}
														{notif?.length === 0 && (
															<Button className={classes.ButtonAlerts}>
																<Alert severity="info">
																	<AlertTitle>NOT OPEN ISSUE</AlertTitle>
																</Alert>
															</Button>
														)}
														<Button
															onClick={() => history.push(`${path}/task`)}
															style={{
																minWidth: "100%",
															}}
														>
															View More
														</Button>
													</Box>
												</Popover>
											</>
										)}
									</PopupState>
									<div
										style={{
											display: "flex",
											alignItems: "center",
										}}
									>
										<NavbarItem />
									</div>
								</Grid>
							</div>
						</Grid>
					</Toolbar>
				</AppBar>
				<main className={classes.content}>{props.children}</main>
			</Grid>
			<div className={classes.footer}>
				<SpeedDial />
			</div>
		</>
	);
};

export default Home;
